import { useState } from 'react';

export function useStateToggleBoolean(initial: boolean): [boolean, VoidFunction] {
	const [value, setValue] = useState<boolean>(initial);
	return [value, () => setValue(!value)];
}
